import type { GameModule } from '../../core/contracts'
import {
  INITIAL_LEVEL,
  MAX_LEVEL,
  MIN_LEVEL,
  REFERENCE_RT_MS,
  evaluate,
  generateRound,
} from './logic'
import type { MissingAnswer, MissingRound } from './logic'
import { MissingOneView } from './view'

export const missingOne: GameModule<MissingRound, MissingAnswer> = {
  id: 'missing-one',
  titleKey: 'game.missingOne',
  hintKey: 'game.missingOne.hint',
  discipline: 'memory',
  metric: 'span',
  difficulty: { min: MIN_LEVEL, max: MAX_LEVEL, initial: INITIAL_LEVEL },
  roundsPerSession: 4,
  referenceRtMs: REFERENCE_RT_MS,
  generateRound,
  evaluate,
  View: MissingOneView,
}

export * from './logic'
